import React from 'react';
import * as S from './styles';

const ImageOverlay = (props = {}) => <S.ImageOverlay align={props.align}>{props.children}</S.ImageOverlay>;

export default ImageOverlay;
